export class ViewTabModel {
    title: string;
    disabled: boolean;
    removable: boolean;
    active: boolean;
    componentName: any;
    id: any;
    ticketId: any;
    ticketCategory:number;
    tabIndex:number;
    isView:boolean;
}


// WEBPACK FOOTER //
// ./src/app/customerservice/interface/ticketingsystem/view-tab-model.ts